import React, { useEffect, useState } from 'react';
import { Timer } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function UrgencyBar() {
  const {
    language
  } = useLanguage();
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Set target date to 3 days from now
    const targetDate = new Date();
    targetDate.setDate(targetDate.getDate() + 3);
    const interval = setInterval(() => {
      const now = new Date();
      const difference = targetDate.getTime() - now.getTime();
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor(difference / (1000 * 60 * 60) % 24),
          minutes: Math.floor(difference / 1000 / 60 % 60),
          seconds: Math.floor(difference / 1000 % 60)
        });
      } else {
        clearInterval(interval);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div className="bg-brand-purple text-white py-2 px-4 sticky top-0 z-50 flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-6 text-sm font-medium shadow-[0_0_15px_rgba(139,47,201,0.5)]" data-id="element-437">
      <div className="flex items-center gap-2" data-id="element-438">
        <span className="w-2 h-2 rounded-full bg-brand-cyan animate-pulse" data-id="element-439"></span>
        <span data-id="element-440">
          {language === 'es' ? 'OFERTA DE LANZAMIENTO — SOLO POR TIEMPO LIMITADO' : 'LAUNCH OFFER — LIMITED TIME ONLY'}
        </span>
      </div>
      <div className="flex items-center gap-2 bg-black/20 px-3 py-1 rounded-full" data-id="element-441">
        <Timer className="w-4 h-4 text-brand-cyan" data-id="element-442" />
        <span className="font-mono font-bold tracking-wider" data-id="element-443">
          {String(timeLeft.days).padStart(2, '0')}d :{' '}
          {String(timeLeft.hours).padStart(2, '0')}h :{' '}
          {String(timeLeft.minutes).padStart(2, '0')}m :{' '}
          {String(timeLeft.seconds).padStart(2, '0')}s
        </span>
      </div>
    </div>;
}